import React, { Component, createRef } from "react";
import parse from "html-react-parser";
import LottieWrapVideo from "../../lottie/lottieWrapVideo";
import styled from "styled-components";
import Counter from "../../../assets/counter.inline.svg";
import "../../../sass/components/reuseable_components/_services_hero.scss";
import "../../../sass/pages/components/_hero.scss";
import { gsap } from "gsap";
import SplitText from "gsap/SplitText";
import { Link } from "gatsby";

gsap.registerPlugin(SplitText);

//@import "./pages/components/hero";
const StyledHeading = styled.h2`
  .lines div {
    background: var(--black);
    background: -webkit-linear-gradient(
      right,
      ${(props) => props.customColour1},
      ${(props) => props.customColour2}
    ) !important;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const StyledScroller = styled.span`
  -webkit-text-stroke-color: ${(props) => props.customColour2};
`;

const Line = styled.div`
  background: -webkit-linear-gradient(
    right,
    ${(props) => props.customColour1},
    ${(props) => props.customColour2}
  ) !important;
`;

class ServiceIntroSection extends Component {
  constructor(props) {
    super(props);
    this.countfromRef = createRef();
    this.counterWrap = createRef();
    this.numberRef = createRef();
    this.introSection = createRef();
    this.mySplitText = null;

    this.state = {
      delayAnimation: false,
      customColour1: null,
      customColour2: null,
    };
  }

  componentWillUnmount() {
    this.destroySplitText();
  }

  destroySplitText() {
    this.mySplitText.revert();
  }

  componentDidMount() {
    if (typeof document !== "undefined") {
      this.setState({
        customColour1: document
          .querySelector(".outer-component-wrapper")
          .getAttribute("data-color1"),
        customColour2: document
          .querySelector(".outer-component-wrapper")
          .getAttribute("data-color2"),
      });

      const scrollerHeadings = Array.from(document.querySelectorAll(".scroller .heading"));

      scrollerHeadings.forEach((heading) => {
        let widest = 0;

        if (heading.clientWidth > widest) {
          // console.log(heading.clientWidth)
          widest = heading.clientWidth;
        }

        scrollerHeadings.forEach(
          (heading) => (heading.style.width = widest + window.innerWidth / 4 + "px")
        );
      });
    }

    this.mySplitText = new SplitText(".main_text .split", { type: "lines", linesClass: "lines" });
    this.mySplitText.lines.map((line) => {
      let grandparent = line.parentNode.parentNode;
      let parent = line.parentNode;
      let originalHtml = line.innerHTML;
      let newHtml = `<div>${originalHtml}</div>`;

      line.innerHTML = newHtml;

      grandparent.append(line);
      // console.log(grandparent)

      Array.from(grandparent.querySelectorAll(".lines")).map((line) => {
        setTimeout(
          function () {
            grandparent.classList.add("show");
            line.classList.add("is_inview");
          }.bind(this),
          1
        );
      });

      parent.style.display = "none";
    });

    const addCountdownTimer = this.props.addCountdownTimer;

    this.introSection.current.classList.add("is_inview");

    if (addCountdownTimer === true) {
      var number = this.countfromRef.current.dataset.countfrom;
      var counterWrap = this.counterWrap.current;
      var numberRef = this.numberRef.current;
      var count;

      counterWrap.querySelector(".counteranimate").classList.add("animate");
      function runCountdown() {
        count = setInterval(updateCount, 1000);
      }
      runCountdown();
      function updateCount() {
        number = number - 1;
        if (number == 0) {
          clearInterval(count);
          counterWrap.classList.add("hide");
        }
        numberRef.innerHTML = number;
      }
    }
  }
  render() {
    let classList = ["services-hero", "contains-custom-colour", "section"];

    if (this.removeBottomMargin === true) {
      classList.push("no-margin");
    }

    return (
      <section
        ref={this.introSection}
        className={`${classList.join(" ")}`}
        data-bg-shape="show_shape">
        <div className="main_text clearfix">
          <div className="wrapper-900 clearfix">
            {/* <div className="the_services" id="lottie_wrap" > */}
            <div
              className="the_services"
              id="lottie_wrap"
              data-target={this.props.scrollingBackgroundText.toLowerCase()}>
              <LottieWrapVideo
                video={this.props.animatedIconVideoUrl}
                addCountdownDelay={this.props.addCountdownTimer}
              />
              {this.props.ctaButton && (
                <Link
                  to={this.props.ctaButton.url}
                  className="heroBtn button btn btn--grad link desktop"
                  target={this.props.ctaButton.target}>
                  <span>{this.props.ctaButton.title}</span>
                </Link>
              )}
            </div>
            {this.props.addCountdownTimer === true ? (
              <div className="counter-wrap" ref={this.counterWrap}>
                <div
                  className="number-wrap"
                  ref={this.countfromRef}
                  data-countfrom={this.props.countdownFrom}>
                  <span className="number" ref={this.numberRef}>
                    {this.props.countdownFrom}
                  </span>
                </div>
                <Counter />
              </div>
            ) : (
              " "
            )}

            <h1 className="label">{this.props.agencyPrefixText} Agency</h1>

            <StyledHeading
              customColour1={this.state.customColour1}
              customColour2={this.state.customColour2}
              className={this.props.addCountdownTimer === true ? "has_timer" : ""}>
              <div className="split">{parse(this.props.heading)}</div>
            </StyledHeading>
            <div className="desc_text">{parse(this.props.text)}</div>

            {this.props.source.length > 2 ? <div className="source">{this.props.source}</div> : ""}
            {console.log(this.props)}
            {this.props.ctaButton && (
              <Link
                to={this.props.ctaButton.url}
                className="heroBtn button btn btn--grad link mobile"
                target={this.props.ctaButton.target}>
                <span>{this.props.ctaButton.title}</span>
              </Link>
            )}

            {this.props.showBreadcrumbs === true ? (
              <div className="breadcrumb-wrapper">
                <Line
                  customColour1={this.state.customColour1}
                  customColour2={this.state.customColour2}
                  className="line"></Line>
                <div className="breadcrumbs">
                  <Link to="/">Home</Link>
                  <span className="divider">&gt;</span>
                  <Link to={`${this.props.pageInfo.base}`}>{this.props.pageInfo.baseName}</Link>
                  {this.props.specifyGrandparentPage !== null &&
                  this.props.specifyGrandparentPage !== undefined ? (
                    <>
                      <span className="divider">&gt;</span>
                      <Link to={this.props.specifyGrandparentPage.uri}>
                        {this.props.specifyGrandparentPage.acf_serviceFields.longTitle}
                      </Link>{" "}
                      <span>&gt;</span>{" "}
                    </>
                  ) : (
                    ""
                  )}
                  <span className="divider">&gt;</span>
                  {this.props.specifyParentPage !== null &&
                  this.props.specifyParentPage !== undefined ? (
                    <>
                      <Link to={this.props.specifyParentPage.uri}>
                        {this.props.specifyParentPage.acf_serviceFields.longTitle}
                      </Link>{" "}
                      <span>&gt;</span>{" "}
                    </>
                  ) : (
                    ""
                  )}
                  <span>{this.props.pageInfo.slugName}</span>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="scroller">
          <StyledScroller
            customColour1={this.state.customColour1}
            customColour2={this.state.customColour2}
            className="heading-1 heading">
            <span className="offset">{this.props.scrollingBackgroundText}</span>
          </StyledScroller>
          <StyledScroller
            customColour1={this.state.customColour1}
            customColour2={this.state.customColour2}
            className="heading-2 heading">
            <span className="offset">{this.props.scrollingBackgroundText}</span>
          </StyledScroller>
        </div>
      </section>
    );
  }
}

export default ServiceIntroSection;
